import { createAsyncThunk } from '@reduxjs/toolkit';
import { PayoffApi, GetPayoffPaymentsResponse } from 'api/PayoffApi';

import { ErrorResponse } from './ErrorResponse';

export const createGetPayoffPaymentsThunk = (api: PayoffApi) =>
  createAsyncThunk('payoffPayments/getPayoffPayments', async (applicationId: string, thunkApi) => {
    try {
      const response: GetPayoffPaymentsResponse = await api.getPayoffPayments(applicationId);
      return response;
    } catch (error: unknown) {
      thunkApi.rejectWithValue((error as ErrorResponse).response.data);
      throw error;
    }
  });
